import React from 'react';
import { Link } from 'react-router-dom';
import { TableText } from '@patternfly/react-table';

export const linkCell = (path, text) => (
  <TableText>
    <Link to={path}>{text}</Link>
  </TableText>
);



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_openscap-5.2.2-2.fm3_3.el8.noarch/usr/share/gems/gems/foreman_openscap-5.2.2/webpack/helpers/tableHelper.js